import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

import { Field } from '@core/api/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'gogis-errors-input',
  standalone: false,
  templateUrl: './errors-input.component.html',
})
export class ErrorsInputComponent {
  @Input() errors: ValidationErrors | null;
  @Input() field: Field | { label: string };
}
